/*
 * Custom B2B (10.09.2026): Haendlerbereich (Downloads) und Preisliste
 * Gehoert zu sections/b2b-downloads.liquid, sections/b2b-price-list.liquid und assets/b2b-downloads.css
 */
(function () {
  var JSZIP_URL = 'https://cdnjs.cloudflare.com/ajax/libs/jszip/3.10.1/jszip.min.js';

  function absoluteUrl(url) {
    return url.indexOf('//') === 0 ? window.location.protocol + url : url;
  }

  /* Bilder als JPG/PNG anfordern (nicht WebP/AVIF), damit Haendler sie ueberall verwenden koennen */
  function fetchImage(url) {
    return fetch(absoluteUrl(url), { headers: { Accept: 'image/jpeg,image/png;q=0.9,*/*;q=0.1' } }).then(function (response) {
      if (!response.ok) throw new Error('Bild konnte nicht geladen werden (' + response.status + ')');
      return response.blob();
    });
  }

  function extensionFor(blob) {
    if (blob.type === 'image/png') return 'png';
    if (blob.type === 'image/webp') return 'webp';
    if (blob.type === 'image/avif') return 'avif';
    return 'jpg';
  }

  function saveBlob(blob, filename) {
    var link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    setTimeout(function () {
      URL.revokeObjectURL(link.href);
      link.remove();
    }, 4000);
  }

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      if (window.JSZip) return resolve();
      var script = document.createElement('script');
      script.src = src;
      script.onload = resolve;
      script.onerror = function () { reject(new Error('ZIP-Funktion konnte nicht geladen werden.')); };
      document.head.appendChild(script);
    });
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);

    var area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.opacity = '0';
    document.body.appendChild(area);
    area.select();
    document.execCommand('copy');
    area.remove();
    return Promise.resolve();
  }

  function flash(button, text) {
    var original = button.dataset.originalText || button.textContent;
    button.dataset.originalText = original;
    button.textContent = text;
    setTimeout(function () { button.textContent = original; }, 1800);
  }

  /* -------------------------------------------------------------------------------------------------------------------
   * Downloadbereich
   * ----------------------------------------------------------------------------------------------------------------- */
  if (!window.customElements.get('b2b-downloads')) {
    class B2BDownloads extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;
        this._initialized = true;
        this.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('input', this.onInput.bind(this));
      }

      setStatus(product, text, type) {
        var status = product && product.querySelector('[data-status]');
        if (!status) return;
        status.textContent = text;
        status.className = 'b2b-dl__status text-sm' + (type ? ' is-' + type : '');
      }

      onInput(event) {
        var input = event.target;
        if (!input.matches || !input.matches('[data-filter]')) return;

        var term = input.value.trim().toLowerCase();
        var product = input.closest('.b2b-dl__product');
        product.querySelectorAll('[data-item]').forEach(function (item) {
          item.hidden = term !== '' && (item.dataset.search || '').indexOf(term) === -1;
        });
      }

      onClick(event) {
        var target = event.target;

        var downloadButton = target.closest('[data-download]');
        if (downloadButton) return this.downloadSingle(downloadButton);

        var zipButton = target.closest('[data-zip]');
        if (zipButton) return this.downloadZip(zipButton);

        var copyButton = target.closest('[data-copy]');
        if (copyButton) {
          var box = copyButton.closest('.b2b-dl__text-box');
          var source = box && box.querySelector('[data-copy-source]');
          if (!source) return;
          copyText(source.innerText.trim()).then(function () { flash(copyButton, 'Kopiert ✓'); });
        }
      }

      downloadSingle(button) {
        var item = button.closest('[data-item]');
        var product = button.closest('.b2b-dl__product');
        var self = this;

        button.disabled = true;
        fetchImage(item.dataset.srcOriginal)
          .then(function (blob) {
            saveBlob(blob, item.dataset.name + '.' + extensionFor(blob));
          })
          .catch(function (error) { self.setStatus(product, error.message, 'error'); })
          .finally(function () { button.disabled = false; });
      }

      async downloadZip(button) {
        var product = button.closest('.b2b-dl__product');
        var size = button.dataset.size === 'original' ? 'srcOriginal' : 'srcWeb';
        var items = Array.prototype.filter.call(product.querySelectorAll('[data-item]'), function (item) { return !item.hidden; });
        if (!items.length || this._busy) return;

        this._busy = true;
        var buttons = product.querySelectorAll('[data-zip]');
        buttons.forEach(function (b) { b.disabled = true; });

        try {
          this.setStatus(product, 'ZIP wird vorbereitet …');
          await loadScript(JSZIP_URL);

          var zip = new window.JSZip();
          var done = 0;
          var usedNames = {};
          var self = this;
          var queue = items.slice();

          async function worker() {
            while (queue.length) {
              var item = queue.shift();
              var blob = await fetchImage(item.dataset[size]);
              var name = item.dataset.name;
              usedNames[name] = (usedNames[name] || 0) + 1;
              if (usedNames[name] > 1) name += '-' + usedNames[name];
              zip.file(name + '.' + extensionFor(blob), blob);
              done += 1;
              self.setStatus(product, 'Bilder werden geladen … ' + done + ' / ' + items.length);
            }
          }

          await Promise.all([worker(), worker(), worker(), worker()]);

          this.setStatus(product, 'ZIP wird erstellt …');
          var content = await zip.generateAsync({ type: 'blob' });
          var suffix = size === 'srcOriginal' ? 'original' : '2000px';
          saveBlob(content, (product.dataset.productHandle || 'bilder') + '-bilder-' + suffix + '.zip');
          this.setStatus(product, '✓ ' + items.length + ' Bilder heruntergeladen.', 'success');
        } catch (error) {
          this.setStatus(product, error.message || 'Download fehlgeschlagen.', 'error');
        } finally {
          this._busy = false;
          buttons.forEach(function (b) { b.disabled = false; });
        }
      }
    }

    window.customElements.define('b2b-downloads', B2BDownloads);
  }

  /* -------------------------------------------------------------------------------------------------------------------
   * Preisliste
   * ----------------------------------------------------------------------------------------------------------------- */
  if (!window.customElements.get('b2b-price-list')) {
    class B2BPriceList extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;
        this._initialized = true;

        var self = this;
        this.addEventListener('click', function (event) {
          if (event.target.closest('[data-print]')) window.print();
          if (event.target.closest('[data-csv]')) self.downloadCsv();
        });

        var toggle = this.querySelector('[data-toggle-details]');
        if (toggle) {
          toggle.addEventListener('change', function () {
            self.querySelectorAll('[data-details]').forEach(function (details) { details.open = toggle.checked; });
          });
        }
      }

      downloadCsv() {
        var rows = this.querySelectorAll('[data-row]');
        var hasBarcode = Array.prototype.some.call(rows, function (row) { return row.dataset.barcode; });

        function cell(value) {
          var text = String(value == null ? '' : value);
          return /[";\n]/.test(text) ? '"' + text.replace(/"/g, '""') + '"' : text;
        }

        var header = ['Artikelnummer', 'Produkt', 'Farbe', 'Ausführung', 'Preis netto (EUR)'];
        if (hasBarcode) header.push('EAN');

        var lines = [header.map(cell).join(';')];
        rows.forEach(function (row) {
          var price = ((parseInt(row.dataset.price, 10) || 0) / 100).toFixed(2).replace('.', ',');
          var line = [row.dataset.sku, row.dataset.product, row.dataset.color, row.dataset.variant, price];
          if (hasBarcode) line.push(row.dataset.barcode);
          lines.push(line.map(cell).join(';'));
        });

        /* UTF-8 mit BOM und Semikolon, damit Excel (DE) Umlaute und Spalten korrekt erkennt */
        var blob = new Blob(['﻿' + lines.join('\r\n')], { type: 'text/csv;charset=utf-8' });
        saveBlob(blob, (this.dataset.filename || 'preisliste') + '.csv');
      }
    }

    window.customElements.define('b2b-price-list', B2BPriceList);
  }
})();
